import { useState, useRef, useMemo } from 'react'

import { useOnClickOutside } from 'hooks/listeners'

import { Setting } from 'state/user/types'
import { useUpdateSetting, useSettings } from 'state/user/hooks'

import { Icon, Toggle, Tooltip } from 'components/ui'

import {
  Wrap,
  Menu,
  Overlay,
  MenuItem,
  MenuHeader,
  MenuContent,
  MenuItemIcon,
  MenuItemInfo,
  MenuItemTitle,
  TriggerElement,
  SettingsButton,
  MenuHeaderTitle,
  MenuHeaderClose,
  MenuItemSubTitle,
  MenuHeaderNothing,
} from './Style'

const Settings = () => {
  const settings = useSettings()
  const updateSetting = useUpdateSetting()

  const clickOutsideRef = useRef(null)

  const [isOpenMenu, setOpenMenu] = useState(false)

  const isMaxApprove = useMemo(() => settings[Setting.IS_MAX_APPROVE], [settings])
  const isShowAddressGenerator = useMemo(() => settings[Setting.SHOW_ADDRESS_GENERATOR], [settings])

  const handleClickMenu = () => {
    setOpenMenu(!isOpenMenu)
  }

  const handleClickOutside = () => {
    setOpenMenu(false)
  }

  const handleChangeApproveSetting = async () => {
    updateSetting(Setting.IS_MAX_APPROVE, !isMaxApprove)
  }

  const handleChangeAddressGeneratorSetting = async () => {
    updateSetting(Setting.SHOW_ADDRESS_GENERATOR, !isShowAddressGenerator)
  }

  const maxApproveToggleText = useMemo(
    () => (isMaxApprove ? 'change default setting' : 'use max amount'),
    [isMaxApprove],
  )

  const addressGeneratorToggleText = useMemo(
    () => (isShowAddressGenerator ? 'close address generator' : 'use address generator'),
    [isShowAddressGenerator],
  )

  useOnClickOutside(clickOutsideRef, handleClickOutside)

  return (
    <Wrap ref={clickOutsideRef}>
      <SettingsButton type='symbol' size='symbol' aria-label='Settings' onClick={handleClickMenu}>
        <Icon name='settings' />
      </SettingsButton>

      {isOpenMenu && (
        <>
          <Menu>
            <MenuHeader>
              <MenuHeaderNothing />
              <MenuHeaderTitle type='start'>_global-settings</MenuHeaderTitle>
              <MenuHeaderClose onClick={handleClickMenu}>
                <Icon name='close' size='large' />
              </MenuHeaderClose>
            </MenuHeader>

            <MenuContent type='global'>
              {/*<CustomRpc />*/}

              <MenuItem htmlFor='checkbox-toggle-maxApprove'>
                <MenuItemIcon>
                  <Icon name='money' size='default' />
                </MenuItemIcon>
                <TriggerElement>
                  <Toggle id='checkbox-toggle-maxApprove' isActive={isMaxApprove} toggle={handleChangeApproveSetting} />
                </TriggerElement>
                <MenuItemInfo>
                  <MenuItemTitle id='maxAmountApprove'>Max approve amount</MenuItemTitle>
                  <Tooltip
                    id='maxAmountApprove'
                    content={`The tool defaults to providing the maximum approval amount.\n\nTo enhance the convenience of the service, saving time and reducing network fees, you can toggle to use the exact amount instead.`}
                  />
                  <MenuItemSubTitle>{maxApproveToggleText}</MenuItemSubTitle>
                </MenuItemInfo>
              </MenuItem>

              <MenuItem htmlFor='checkbox-toggle-addressGenerator'>
                <MenuItemIcon>
                  <Icon name='flashFile' size='default' />
                </MenuItemIcon>
                <TriggerElement>
                  <Toggle
                    id='checkbox-toggle-addressGenerator'
                    isActive={isShowAddressGenerator}
                    toggle={handleChangeAddressGeneratorSetting}
                  />
                </TriggerElement>
                <MenuItemInfo>
                  <MenuItemTitle id='addressGenerator'>Address generator</MenuItemTitle>
                  <Tooltip
                    id='addressGenerator'
                    content={`The block for address generator appears on Step "1-prepare".`}
                  />
                  <MenuItemSubTitle>{addressGeneratorToggleText}</MenuItemSubTitle>
                </MenuItemInfo>
              </MenuItem>

              {/* <MenuItem>
                <MenuItemIcon>
                  <Icon name='moon' size='extraMedium' />
                </MenuItemIcon>
                <TriggerElement>
                  <Badge>soon</Badge>
                </TriggerElement>
                <MenuItemInfo>
                  <MenuItemTitle>Change theme</MenuItemTitle>
                  <MenuItemSubTitle>dark color theme dApp</MenuItemSubTitle>
                </MenuItemInfo>
              </MenuItem> */}
            </MenuContent>
          </Menu>

          <Overlay isOpen={isOpenMenu} onClick={handleClickMenu} role='presentation' />
        </>
      )}
    </Wrap>
  )
}

export { Settings }
